import { mapGaugesProperties } from 'app/utils/entities/match_data';

const getTeamStatsLines = (data: TeamsStatsBlockMatch): GaugeStatLine<TeamStats>[] => {
  switch (data.videogame_slug) {
    case 'dota-2': {
      const properties: StatProperties<TeamStatsDota2>[] = [
        { name: 'winrate' },
        { name: 'first_blood_percentage' },
        { name: 'first_tower_percentage' },
        { name: 'first_roshan_percentage' },
        { name: 'first_barracks_percentage' },
        { name: 'first_to_5_kills_percentage' },
        { name: 'first_to_10_kills_percentage' },
        { name: 'first_to_15_kills_percentage' }
      ];

      return mapGaugesProperties(
        properties,
        data.opponents.at(0)?.stats as TeamStatsDota2,
        data.opponents.at(1)?.stats as TeamStatsDota2,
        false
      ) as GaugeStatLine<TeamStats>[];
    }
    case 'cs-go': {
      const properties: StatProperties<TeamStatsCs>[] = [
        { name: 'games_winrate' },
        { name: 'rounds_winrate' },
        { name: 'terrorists_rounds_winrate' },
        { name: 'counter_terrorists_rounds_winrate' },
        { name: 'pistol_winrate' }
      ];
      return mapGaugesProperties(
        properties,
        data.opponents.at(0)?.stats as TeamStatsCs,
        data.opponents.at(1)?.stats as TeamStatsCs,
        false
      ) as GaugeStatLine<TeamStats>[];
    }
  }

  return [];
};

export { getTeamStatsLines };
